import { render, staticRenderFns } from "./RegionBordersSettingEditModal.vue?vue&type=template&id=6ecce029&"
import script from "./RegionBordersSettingEditModal.vue?vue&type=script&lang=js&"
export * from "./RegionBordersSettingEditModal.vue?vue&type=script&lang=js&"
import style0 from "./RegionBordersSettingEditModal.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports